import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PipesModule } from '../../pipes/pipes.module';

import { ButtonComponent } from '../button/button.component';
import { ExpandIconComponent } from '../expand-icon/expand-icon.component';
import { TableCardComponent } from './table-card.component';
import { TableCardColumnTemplateDirective } from './column/table-card-column-template.directive';
import { TableCardColumnComponent } from './column/table-card-column.component';
import { TableCardHeaderComponent } from './header/table-card-header.component';
import { TableCardSubHeaderComponent } from './sub-header/table-card-sub-header.component';
import { TableCardActionComponent } from './action/table-card-action.component';
import { TableCardFooterComponent } from './footer/table-card-footer.component';

@NgModule({
  imports: [
    CommonModule,
    PipesModule,
    ButtonComponent,
    ExpandIconComponent,
    TableCardComponent,
    TableCardHeaderComponent,
    TableCardSubHeaderComponent,
    TableCardActionComponent,
    TableCardFooterComponent,
    TableCardColumnTemplateDirective,
    TableCardColumnComponent
  ],
  exports: [
    TableCardComponent,
    TableCardHeaderComponent,
    TableCardSubHeaderComponent,
    TableCardActionComponent,
    TableCardFooterComponent,
    TableCardColumnTemplateDirective,
    TableCardColumnComponent
  ]
})
export class TableCardModule {
}
